import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { DigitalAsset } from 'modules/domain/digitalAsset/types'
import { EntityMetadata } from 'modules/domain/types'

const digitalAssetsDict = (state: AppGlobalState) => state.digitalAsset.items
const ids = (state: AppGlobalState) => state.digitalAsset.ids
const digitalAsset = (state: AppGlobalState, id: string): DigitalAsset | undefined => state.digitalAsset.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<DigitalAsset> =>
  state.digitalAsset.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }

const itemFetchProgress = (state: AppGlobalState) => state.digitalAsset.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.digitalAsset.listFetchProgress
const listFetchNextProgress = (state: AppGlobalState) => state.digitalAsset.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.digitalAsset.listFetchNextError
const listFetchError = (state: AppGlobalState) => state.digitalAsset.listFetchError
const digitalAssetList = createSelector(digitalAssetsDict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: DigitalAsset[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.digitalAsset.filter
const sorting = (state: AppGlobalState) => state.digitalAsset.sorting
const page = (state: AppGlobalState) => state.digitalAsset.page
const total = (state: AppGlobalState) => state.digitalAsset.total
const updateProgress = (state: AppGlobalState) => state.digitalAsset.updateProgress
const updateError = (state: AppGlobalState) => state.digitalAsset.updateError
const updateErrorDetail = (state: AppGlobalState) => state.digitalAsset.updateErrorDetail
const removeProgress = (state: AppGlobalState) => state.digitalAsset.removeProgress
const addProgress = (state: AppGlobalState) => state.digitalAsset.addProgress
const addError = (state: AppGlobalState) => state.digitalAsset.addError
const addErrorDetail = (state: AppGlobalState) => state.digitalAsset.addErrorDetail
const hasNext = (state: AppGlobalState) => state.digitalAsset.total > state.digitalAsset.ids.length
const pageSize = (state: AppGlobalState) => state.digitalAsset.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.digitalAsset.total / state.digitalAsset.pageSize)
const drafts = (state: AppGlobalState) => state.digitalAsset.drafts
const metaFetchProgress = (state: AppGlobalState) => state.digitalAsset.itemMetaDataFetchProgress
const uploadCompanyType = (state: AppGlobalState) => state.digitalAsset.uploadCompanyType

const DigitalAssetSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  addError,
  addErrorDetail,
  updateError,
  updateErrorDetail,
  digitalAssetsDict,
  ids,
  digitalAsset,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  digitalAssetList,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  pages,
  drafts,
  metaFetchProgress,
  uploadCompanyType,
}

export default DigitalAssetSelectors
